import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer1 from "./components/Footer1";
import Footer from "./components/Footer";
import Lenis from "lenis";
import ContactForm from "./components/ContactForm";
import DynamicPage from "./components/DynamicPage";
import ScrollToTop from "./components/ScrollToTop";
import ProvidersModels from "./components/ProvidersModels";
import Register from "./components/Register";
import Llminsight from "./components/Llminsight-saas";
import PrivacyPolicy from "./components/PrivacyPolicy";

const App = () => {
  useEffect(() => {
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);

      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  return (
    <Router>
      <ScrollToTop /> {/* Ensure scroll to top on route change */}
      <Routes>
        <Route path="/llminsight-saas" element={<Llminsight />} />
        <Route
          path="*"
          element={
            <>
              <Navbar />
              <div style={{ marginTop: "64px", padding: "40px" }}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/:pageId" element={<DynamicPage />} />
                  <Route path="/providers" element={<ProvidersModels />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                </Routes>
              </div>
              <ContactForm />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
